<template>
  <div>
    <videos-dialog ref="videosDialog" @submit="dialogSubmitted" />
    <div class="box">
      <img v-if="selectedVideo" class="thumbnail" :src="src" />
      <div class="image-info">
        <el-button @click="openDialog" type="info" class="open-dialog-button">
          <i class="fa fa-file-image-o"></i> Wybierz lub prześlij wideo
        </el-button>
      </div>
      <el-button
        @click.stop="removeVideo"
        class="remove-button"
        v-if="value"
        size="mini"
        icon="el-icon-delete"
        type="danger"
        title="Usuń wideo"
      >
      </el-button>
    </div>
  </div>
</template>
<script>
import VideosDialog from '@/components/inputs/VideoDialog/'
import { Video } from '@/api'

export default {
  props: ['value'],
  components: {
    VideosDialog
  },
  data() {
    return {
      selectedVideo: null
    }
  },
  methods: {
    removeVideo() {
      this.$emit('input', null)
    },
    openDialog() {
      this.$refs.videosDialog.openDialog()
    },
    dialogSubmitted(video) {
      this.$emit('input', video)
    },
    fetchSelectedVideo() {
      Video.get({ id: this.value }).then(response => {
        this.selectedVideo = response.data
      })
    },
    openEditImageDialog() {
      this.$refs.imageEditDialog.openDialog(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        value ? this.fetchSelectedVideo() : (this.selectedVideo = null)
      }
    }
  },
  computed: {
    src() {
      return this.selectedVideo.thumbnail
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 28px;
  top: 28px;
}

.open-dialog-button {
  vertical-align: middle;
}

.thumbnail {
  max-width: 140px;
  vertical-align: middle;
}

.image-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;

  &__title {
    font-weight: 700;
  }

  &__edit-image-icon {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
